import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useHandleChangeHooks from "../../../../../hooks/digitalMarketing/useHandleChangeHooks";
import CustomInput from "../../../../../Component/DigitalMarketing/CustomInput";
import CustomVioletButton from "../../../../../Component/DigitalMarketing/CustomVioletButton";
import CustomRadio from "../../../../../Component/DigitalMarketing/Forms/CustomRadio";
import { useCreatePregnancyMutation } from "../../../../../Service/PatientList";
import useSnackbar from "../../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../../Component/DigitalMarketing/Toast";

const AddPregnancy = (props: any) => {

  const { setPregnancyModal, refetch } = props;
    const location=useLocation()
    const { id, secondaryId } = useParams();
    const {consultantId,appointmentId}=location.state
  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});
  const [selectedLabel, setSelectedLabel] = useState("");
  const { open, message, openSnackBar, type } = useSnackbar();

  // const today = new Date().toISOString().split("T")[0];
  const options = [{ label: "Before Delivery" }, { label: "After Delivery" }];

 const [createPregnancy, { isLoading }] = useCreatePregnancyMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmit(true);
    if (
      (selectedLabel === "Before Delivery" &&
        (!formData.lastMenstrualPeriod ||
          !formData.expectedDeliveryDate ||
          !formData.notesBeforeDelivery)) ||
      (selectedLabel === "After Delivery" &&
        (!formData.actualDeliveryDate ||
          !formData.actualDeliveryTime ||
          !formData.babyGender ||
          !formData.deliveryMethod ||
          !formData.notesAfterDelivery))
    ) {
      console.error("Please fill all required fields.");
      return; // Stop form submission if validation fails
    }
    const payload: any = {
      ...formData,
      type: selectedLabel,
      consultantId:consultantId,
      patientId: id,
    };
      try {
      const res = await createPregnancy(payload).unwrap();
      openSnackBar(res?.message);
      setTimeout(() => {
        setPregnancyModal(false);
        refetch();
      }, 1000);
    } catch (err: any) {
      openSnackBar(
        err?.data?.message || err?.data?.error || "Failed to create pregnancy",
        "error"
      );
    }
  };

  const handleLabelSelect = (label: string) => {
    setSelectedLabel(label);
  };

  const genderOptions = [{ id: "Male" }, { id: "Female" }];
  const deliveryMethodOptions = [{ id: "Normal" }];

//   useEffect(() => {
//     if (isSuccess) {
//       setPregnancyModal(false);
//       refetch();
//     }
//   }, [isSuccess]);

//   useEffect(() => {
//     if (isSuccess && addData) {
//       toast.success(addData?.message);
//     }
//     if (addIsError) {
//       const axiosError = addError as any;
//       const errorMessages = axiosError?.response?.data?.error;
//       toast.error(errorMessages);
//     }
//   }, [isSuccess, addIsError, addError]);
  return (
    <div>
      <Toast open={open} type={type} message={message} />
      <form>
        <div className="mb-3">
          <CustomRadio
            options={options}
            onLabelSelect={handleLabelSelect}
            selectedLabel={selectedLabel}
          />
        </div>

        {selectedLabel === "Before Delivery" && (
          <>
            <CustomInput
              {...formData}
              onChange={handleChange}
              type="date"
              label="Last Menstrual Period"
              validation="required"
              submit={submit}
              name="lastMenstrualPeriod"
              setFormData={setFormData}
            />

            <CustomInput
              {...formData}
              onChange={handleChange}
              type="date"
              label="Expected Delivery Date"
              validation="required"
              submit={submit}
              name="expectedDeliveryDate"
              setFormData={setFormData}
            />

            <CustomInput
              {...formData}
              onChange={handleChange}
              type="textarea"
              label="Notes"
              validation="required"
              submit={submit}
              name="notesBeforeDelivery"
              setFormData={setFormData}
            />
          </>
        )}
        {selectedLabel === "After Delivery" && (
          <>
            <div className="row">
              <div className="col-6">
                <CustomInput
                  {...formData}
                  onChange={handleChange}
                  type="date"
                  label="Actual Delivery Date"
                  validation="required"
                  submit={submit}
                  name="actualDeliveryDate"
                  setFormData={setFormData}
                />
              </div>
              <div className="col-6">
                <CustomInput
                  {...formData}
                  onChange={handleChange}
                  type="time"
                  label="Actual Delivery Time"
                  validation="required"
                  submit={submit}
                  name="actualDeliveryTime"
                  setFormData={setFormData}
                />
              </div>
            </div>
            <CustomInput
              label="Baby Gender"
              type="select"
              option={genderOptions}
              labelKey="id"
              valueKey="id"
              validation="required"
              submit={submit}
              {...formData}
              onChange={handleChange}
              name="babyGender"
              setFormData={setFormData}
            />
            <CustomInput
              label="Delivery Method"
              type="select"
              option={deliveryMethodOptions}
              labelKey="id"
              valueKey="id"
              validation="required"
              submit={submit}
              {...formData}
              onChange={handleChange}
              name="deliveryMethod"
              setFormData={setFormData}
            />
            <CustomInput
              {...formData}
              onChange={handleChange}
              type="textarea"
              label="Notes"
              validation="required"
              submit={submit}
              name="notesAfterDelivery"
              setFormData={setFormData}
            />
          </>
        )}

        <div className="mt-3 d-flex justify-content-end">
          <CustomVioletButton
            btnLabel="Add Pregnancy"
            onClick={handleSubmit}
            // isLoading={isPending}
          />
        </div>
      </form>
    </div>
  );
};

export default AddPregnancy;
